import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';
import { useSelector } from 'react-redux';
import { routePermissionMap, privateRoutesPath } from './index';

/**
 * RequirePermission — Route-level RBAC guard for React Router v5.
 *
 * Wraps a <Route> and does the following:
 *  1. While rolebasedData is fetching (null/undefined), provisionally renders <Route {...props} />
 *     so there are no dark screen flashes or stuck loaders on hard refresh / session expiry.
 *  2. Once rolebasedData is loaded, matches location.pathname against routePermissionMap via matchPath (exact).
 *  3. If permission is falsy in rolebasedData, redirects to /biztantu/unauthorized.
 */
const RequirePermission = (props) => {
    const location = useLocation();
    const rolebasedData = useSelector((state) => state?.owner?.rolebasedData);

    // --- 1. Evaluate permission only when rolebasedData has loaded ---
    if (rolebasedData !== null && rolebasedData !== undefined) {
        let requiredPermission = undefined;

        for (const [pathPattern, permissionKey] of Object.entries(routePermissionMap)) {
            const match = matchPath(location.pathname, {
                path: pathPattern,
                exact: true,
                strict: false,
            });
            if (match) {
                requiredPermission = permissionKey;
                break;
            }
        }

        // Check permission if mapped and not null
        if (requiredPermission !== undefined && requiredPermission !== null) {
            const hasPermission = Boolean(rolebasedData[requiredPermission]);
            if (!hasPermission) {
                return (
                    <Redirect
                        to={{
                            pathname: privateRoutesPath.UNAUTHORIZED,
                            state: { from: location },
                        }}
                    />
                );
            }
        }
    }

    // --- 2. Render route component while loading or when permitted ---
    return <Route {...props} />;
};

export default RequirePermission;
